<style>
table {
    border: 1px solid black;
}

td {
    border: 1px solid black;
}
</style>

<template>
    <div style="margin: 10px;">
        <h2>Welcome! You've made it here!</h2>

        <h2>Story Trace</h2>

        <div>
            <label>Workspace</label>
            <input type="text" v-model="formData.workspaceId" />
        </div>

        <div>
            <label>Module</label>
            <input type="text" v-model="formData.moduleId" />
        </div>

        <div>
            <label>Activity</label>
            <input type="text" v-model="formData.activityId" />
        </div>

        <div>
            <label>Listing</label>
            <input type="text" v-model="formData.listingId" />
        </div>

        <div>
            <label>Entry</label>
            <input type="text" v-model="formData.entryId" />
        </div>

        <!-- <div>
            <label>Automation</label>
            <input type="text" v-model="formData.automationId" />
        </div> -->

        <hr/>
        <div>
            <label>Request</label>
            <input type="text" v-model="formData.requestId" />
        </div>

        <!-- <div>
            <label>Data</label>
            <textarea style="width: 200px; height: 200px;" v-model="formData.data"></textarea>
        </div> -->
        <button type="submit" @click="ask(formData)">Trace</button>

        <div v-if="response && response.data">
            <div><h2>{{response.data.workspace}}</h2></div>
            <div v-if="response.data.request.traces.some(x => x)">On {{ moment(response.data.request.traces[0].start).format('LLLL') }} by {{ response.data.request.traces[0].by }}</div>
            
            <div v-for="item in response.data.request.traces">
                <AutomationRunTrace :run="item"></AutomationRunTrace>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { classificationStore } from "./components/store/classificationStore";
import { clientStore } from "./components/store/clientStore";
import { authorizationStore } from "./components/store/authorizationStore";
import { store } from './components/store/canvasDesignStore';
import AutomationRunTrace from "./components/admin/automationRunTrace.vue";
import moment from "moment";

export default {
    data: () => ({
        formData: {
            requestId: '0v4dWDmy'
        },
        response: {}
    }),
    components: {
        AutomationRunTrace
    },
    store,
    methods: {
        moment,
        formatDateTime(date) {
            const options = {
                year: "2-digit",
                month: "2-digit",
                day: "2-digit",
                hour: "numeric",
                minute: "2-digit",
                second: "2-digit",
                hour12: true, // For AM/PM format
            };

            // Use Intl.DateTimeFormat for base formatting
            const formatter = new Intl.DateTimeFormat("en-US", options);
            const parts = formatter.formatToParts(date);

            // Extract and format components
            const year = parts.find((part) => part.type === "year").value;
            const month = parts.find((part) => part.type === "month").value;
            const day = parts.find((part) => part.type === "day").value;
            const hour = parts.find((part) => part.type === "hour").value;
            const minute = parts.find((part) => part.type === "minute").value;
            const second = parts.find((part) => part.type === "second").value;
            const dayPeriod = parts.find((part) => part.type === "dayPeriod").value;

            // Combine into the desired format
            return `${year}${month}${day} ${hour}:${minute}:${second} ${dayPeriod}`;
        },
        formatToN2(number) {
            if (number)
                return number.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });
        },
        format(dateTime) {
            return dateTime.toLocaleString(navigator.language);
        },
        async ask(formData) {
            this.response = await this.$store.dispatch("ask", formData);
        }
    }
}





</script>
